import axios from "axios";
import { HOST_API } from "../config";
import { API_ENDPOINTS } from "./apiEndPoints";

//Auth api
export const authApi = axios.create({
  baseURL: HOST_API,
  timeout: 30000,
  headers: {
    "Content-Type": "application/json",
    Accept: "application/json",
    // "Access-Control-Allow-Origin": "*",
  },
});

authApi.interceptors.request.use(
  async function (options) {
    return options;
  },
  function (error) {
    return Promise.reject(error);
  }
);

authApi.interceptors.response.use(
  async function (options) {
    return options;
  },
  function (error) {
    return Promise.reject({ error, data: error.response });
  }
);

//Authorized api
export const eduleyApi = axios.create({
  baseURL: HOST_API,
  // timeout: 30000,
  headers: {
    "Content-Type": "application/json",
    Accept: "application/json",
  },
});

eduleyApi.interceptors.request.use(
  async function (options) {
    options.headers["Authorization"] = `JWT ${localStorage.getItem(
      "accessToken"
    )}`;
    return options;
  },
  function (error) {
    return Promise.reject(error);
  }
);

eduleyApi.interceptors.response.use(
  async function (response) {
    if (response?.status == 403) {
      localStorage.clear();
      window.location.href = "/";
    }
    if (response?.status == 400) {
      localStorage.clear();
      // window.location.href = "/";
    }
    // console.log('Api Response :',response)
    return response;
  },
  function (error) {
    if (error.response?.status == 403) {
      localStorage.clear();
      window.location.href = "/";
    }
    if (error.response?.status == 400) {
      localStorage.clear();
      // window.location.href = "/";
    }
    // console.log('API Error :', error.response)
    return Promise.reject({ error, data: error.response });
  }
);
// i love it

// const checkuserisadmin=await ()=>{
//     try {
//         let res=await eduleyApi.get(``)

//     } catch (error) {

//     }
// }
